import type { InjectionKey } from 'vue'
import type { CpApi } from '@/api'
import type { UserProvider } from '@/plugins/user'

export const apiKey = Symbol() as InjectionKey<CpApi>
export const userKey = Symbol() as InjectionKey<UserProvider>